"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WrapperChooser = exports.ROUTES = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reactRouter = require("react-router");

var _nuiShell = require("@concur/nui-shell");

var _Errors = require("@concur/nui-shell/lib/components/Errors");

var _wwwWrapperCom = _interopRequireDefault(require("@concur/www-wrapper-com"));

var _nuiIntl = _interopRequireWildcard(require("@concur/nui-intl"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var httpCodes = _interopRequireWildcard(require("@concur/nui-shell/lib/httpCode"));

var _App = _interopRequireDefault(require("./App"));

var _listings = _interopRequireDefault(require("../listings"));

var _listing = _interopRequireDefault(require("../listing"));

var _SearchContainer = _interopRequireDefault(require("../search/SearchContainer"));

var _TermsPage = _interopRequireDefault(require("../terms/TermsPage"));

var _utils = require("../utils");

var _utilsModule = require("../utils/utilsModule");

var _HelpContainer = _interopRequireDefault(require("../help/HelpContainer"));

var _config = _interopRequireDefault(require("../config"));

var _NotFoundRedirect = _interopRequireDefault(require("../shared/NotFoundRedirect"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ROUTES = {
  US_PUBLIC: '/app-center',
  EU_PUBLIC: '/app-centre'
}; // silly little thing to let us use the in-product or public header and footer

exports.ROUTES = ROUTES;

var WrapperChooser =
/*#__PURE__*/
function (_React$Component) {
  _inherits(WrapperChooser, _React$Component);

  function WrapperChooser(props) {
    var _this;

    _classCallCheck(this, WrapperChooser);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WrapperChooser).call(this, props));
    var code = (0, _utils.getCountryCode)(props.meta.originalhost);
    props.setCountryCode(code);
    return _this;
  }

  _createClass(WrapperChooser, [{
    key: "render",
    value: function render() {
      var usePublicWrapper = (0, _utils.isPublic)(this.props.location.pathname);

      if (usePublicWrapper) {
        var nuiLangToUse = (0, _utils.getNuiLanguage)(this.props.meta.originalhost);
        var publicLangToUse = (0, _utils.mapCountryToPublicLang)(this.props.meta.country || 'US');
        var localeData = (0, _nuiIntl.getLocaleData)(this.props);
        localeData.lang = nuiLangToUse; // eslint-disable-next-line import/no-dynamic-require, global-require

        var translations = window.NUI_TRANSLATIONS;

        return !this.props.meta.listingNotFound ? _react.default.createElement(_wwwWrapperCom.default, {
          lang: publicLangToUse
        }, _react.default.createElement(_nuiIntl.default, {
          messages: translations,
          localeData: localeData
        }, this.props.children)) : _react.default.createElement(_NotFoundRedirect.default, null);
      }

      return _react.default.createElement(_nuiShell.NuiPageContainer, null, this.props.meta.listingNotFound ? _react.default.createElement(_Errors.ErrorPage, null, _react.default.createElement(_Errors.NotFound, null)) : this.props.children);
    }
  }]);

  return WrapperChooser;
}(_react.default.Component);

exports.WrapperChooser = WrapperChooser;
WrapperChooser.propTypes = {
  location: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
  meta: _propTypes.default.shape({
    originalhost: _propTypes.default.string,
    country: _propTypes.default.string,
    listingFound: _propTypes.default.bool
  }),
  setCountryCode: _propTypes.default.func
};

function mapStateToProps(_ref) {
  var baseUrl = _ref.baseUrl,
      userPrefs = _ref.userPrefs,
      nuiPage = _ref.nuiPage,
      meta = _ref.meta;
  return {
    baseUrl: baseUrl,
    userPrefs: userPrefs,
    nuiPage: nuiPage,
    meta: meta
  };
}

var RRWrapperChooser = (0, _reactRedux.connect)(mapStateToProps, {
  setCountryCode: _utilsModule.setCountryCode
})((0, _reactRouter.withRouter)(WrapperChooser));
var commonRoutes = [_react.default.createElement(_reactRouter.IndexRoute, {
  component: _listings.default,
  key: "Listings"
}), _react.default.createElement(_reactRouter.Route, {
  path: "listings/:id",
  component: _listing.default,
  key: "Listing"
}), _react.default.createElement(_reactRouter.Route, {
  path: "listings/:id/:name",
  component: _listing.default,
  key: "ListingsName"
}), _react.default.createElement(_reactRouter.Redirect, {
  from: "listing/:id/:name",
  to: "listings/:id/:name",
  key: "listingRedirect"
}), _react.default.createElement(_reactRouter.Route, {
  path: "category/:category",
  component: _listings.default,
  key: "Category"
}), _react.default.createElement(_reactRouter.Route, {
  path: "search/:term",
  component: _SearchContainer.default,
  key: "Search"
}), _react.default.createElement(_reactRouter.Route, {
  path: "terms/:name",
  component: _TermsPage.default,
  key: "Terms"
}), _react.default.createElement(_reactRouter.Route, {
  path: "help",
  component: _HelpContainer.default,
  key: "Help"
})];
/* const public404 = (<Route
  path="*" onEnter={(nextState, replace) => {
    replace('/404');
  }}
/>); */

var commonWrapperRoute = _react.default.createElement(_reactRouter.Route, {
  component: RRWrapperChooser
}, _react.default.createElement(_reactRouter.Route, {
  component: _App.default
}, commonRoutes));

var public404 = _react.default.createElement(_reactRouter.Route, {
  path: "*",
  status: httpCodes.NOT_FOUND,
  component: _NotFoundRedirect.default
});

var publicRoute = _react.default.createElement("div", null, commonWrapperRoute, public404);

var _default = _react.default.createElement(_reactRouter.Route, null, _react.default.createElement(_reactRouter.Route, {
  path: _config.default.nui.baseUrl
}, commonWrapperRoute), _react.default.createElement(_reactRouter.Route, {
  path: ROUTES.US_PUBLIC,
  isAnonymous: true
}, publicRoute), _react.default.createElement(_reactRouter.Route, {
  path: ROUTES.EU_PUBLIC,
  isAnonymous: true
}, publicRoute));

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./lib/app/routes.js
// module id = 232
// module chunks = 0